var map = {
	"./default-tabs": "./src/config/default-tabs.json",
	"./default-tabs.json": "./src/config/default-tabs.json",
	"./similar.amone-milize.com": "./src/config/similar.amone-milize.com.json",
	"./similar.amone-milize.com.json": "./src/config/similar.amone-milize.com.json",
	"./similar.milize.ai": "./src/config/similar.milize.ai.json",
	"./similar.milize.ai.json": "./src/config/similar.milize.ai.json",
	"./similar.yahoo-finance.milize.ai": "./src/config/similar.yahoo-finance.milize.ai.json",
	"./similar.yahoo-finance.milize.ai.json": "./src/config/similar.yahoo-finance.milize.ai.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config sync recursive ^\\.\\/.*$";